module.exports = __webpack_public_path__ + "static/media/Retina.0772e276.svg";